export default __webpack_public_path__ + "static/media/4.5dca5849.jpg";